import { post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/cloudECounter/reserveVideo';

export function postInitTransaction() {
    return post(`${url}/initTransaction`);
}

export function postInfo() {
    return post(`${url}/info`);
}

export function postOcr(data) {
    return post(`${url}/identityRecognition/ocr`, data, {
        ...options,
        repeatRequestCancel: true,
        formData: true,
    });
}

export function postValidate(data) {
    return post(`${url}/identityRecognition/validate`, data);
}

export function postAgree(data) {
    return post(`${url}/agreeTerms/agree`, data);
}

export function postCheckMeet(data) {
    return post(`${url}/checkMeet`, data);
}

export function postCheckRecord(data) {
    return post(`${url}/checkRecord`, data, {
        ...options,
        closeAlert: true,        
    });
}

export function postCheckReserveDatetimePeriodApply() {
    return post(`${url}/checkReserveDatetimePeriodApply`, null,{
        ...options,
        closeAlert: true,
    });
}
